import { ICustomizations } from '../types'
import { camelToSnake, camelToKebab, camelToConstant, getAttributeAnyCasing } from '../../utils/caseHelpers'

export { getAttributeAnyCasing } from '../../utils/caseHelpers'

const {
    NAME,
    VERSION,
    OVERLAY_TITLE,
    TITLE,
    TITLE_1,
    TITLE_2,
    TITLE_3,
    FONT_FAMILY,
    TITLE_COLOR,
    TITLE_SIZE,
    TITLE_SIZE_1,
    TITLE_SIZE_2,
    TITLE_SIZE_3,
    TITLE_BOTTOM,
    MARGIN_BOTTOM,
    FONT_COLOR,
    PRICE_FONT_COLOR,
    PRICE_COLOR,
    FONT_SIZE,
    CARD_WIDTH,
    SKINNY_WIDTH,
    SHORT_WIDTH,
    SHORT_HEIGHT,
    DEFAULT_WIDTH,
    MEMBERSHIP_TYPE,
    CODE,
    LISTINGS,
    LISTINGS_TAG_CACHE_COUNT,
    LISTINGS_TAG_CACHE_SELECTOR,
    LOCALIZED_LISTINGS,
    LINK_TEXT,
    LINK_TEXT_1,
    LINK_TEXT_2,
    LINK_TEXT_3,
    BUY_NOW_TEXT,
    LINK_SIZE,
    LINK_SIZE_1,
    LINK_SIZE_2,
    LINK_SIZE_3,
    LINK_COLOR,
    FONT_URL,
    COLORS,
    BANNER_ZID,
    BOTTOM_BANNER_ZID,
    MOBILE_BANNER_ZID,
    HIDE_BANNER_TOP,
    HIDE_BANNER_BOTTOM,
    MOBILE_ZID,
    DISPLAY_ZID,
    SKYSCRAPER_ZID,
    BIDSTREAM_STACK,
    GAM_TAG,
    GAM_TAG_DESC,
    GAM_NETWORK_CODE,
    GAM_CURRENCY,
    USD_TO_CAD_RATE,
    GAM_SLOT_PREFIX,
    GAM_URL_PARSER,
    COL1,
    COL2,
    COL3,
    COL4,
    COL5,
    COL6,
    OPTIMIZE_FCP,
    LOTAME,
    AD_UNITS,
    SCHAIN_SID,
    SCHAIN_ASI,
    S2S_CONFIG,
    CONSENT_MANAGEMENT,
    GROWTHCODE,
    BH_TAG,
    IDENTITY_HUB,
    IX,
    OPENX,
    MEDIANET,
    ACROSS33,
    PUBMATIC,
    YAHOOSSP,
    AMX,
    APPNEXUS,
    MEDIAFUSE,
    RUBICON,
    SOVRN,
    UNRULY,
    EQUATIV,
    SHARETHROUGH,
    IMPROVE_DIGITAL,
    SONOBI,
    NOBID,
    CPMSTAR,
    INSTICATOR,
    YIELDMO,
    EPSILON,
    TRIPLELIFT,
    ONETAG,
    MINUTEMEDIA,
    OMS,
    OPSCO_PREBID,
    SMAATO,
    NATIVO,
    AMAZON_APS,
    BRAVE,
    INMOBI,
    IQX,
    ZETA_GLOBAL_SSP,
    OMNIDEX,
    BREAKPOINTS,
    AD_TYPE,
    STANDALONE_AD_TYPE,
    SAFE_FRAME,
    AD_REFRESH_MAX,
    AD_REFRESH_MAX_MOBILE,
    AD_REFRESH_MAX_IOS_SAFARI,
    AD_REFRESH_INTERVAL,
    LAZY_LOAD_ADS,
    REFRESH_ON_VIEW_ONLY,
    AD_DISABLE_DISPLAY,
    HOUSE_AD_ENABLED,
    AD_STACK,
    AD_STACK_BY_ZONE,
    MAX_FAILED_AUCTIONS,
    PREBID_DEFER,
    PREBID_SRC,
    FLOOR_MULTIPLIER,
    MEDIA_FUSE_WRAPPER,
    ADSENSE_CLIENT_ID,
    GPP_ENABLED,
    WATERMARK,
    WATERMARK_TITLE,
    CSS,
    AUDIGENT,
    BOLTIVE,
    BOLTIVE_CLIENT_ID,
    BOLTIVE_CLIENT_ID_MOBILE,
    STICKY_STYLE,
    GPT_PROXY_URL,
    LOCATION_MAP,
    NO_RESIZE,
    FOOTER,
    SEARCH,
    SEARCH_BOTTOM,
    DISABLE_DARK,
    DISABLE_GPT,
    DARK_CLASS,
    PLACEHOLDER,
    SLUG,
    IMG_BKG,
    IAB_CATS,
    AD_GEO_BLOCK,
    AD_GEO_BLOCK_REFRESH,
    PUB_VENTURES,
    SAAMBAA,
    OPSCO,
    APSTAG,
    BIDSTREAM,
    TCF_VERSION,
    FLIP_CARD_COLOR,
    FLIP_CARD_TITLE,
    FLIP_CARD_SUBTITLE,
    FLIP_CARD_CTA,
    MIN_BID_CACHE_TTL,
    EVENT_HISTORY_TTL,
    SYNCS_PER_BIDDER,
    SYNCS_PER_BIDDER_IOS,
    IDENTITY_ENABLED,
    CUSTOMIZE,
} = process.env

export const defaultCustomizations: ICustomizations = {
    debug: false,
    browse: false,
    customize: parseValue(CUSTOMIZE) !== false,
    version: Number(VERSION),
    overlayTitle: Boolean(OVERLAY_TITLE) || false,
    hideBannerTop: Boolean(HIDE_BANNER_TOP) || false,
    hideBannerBottom: Boolean(HIDE_BANNER_BOTTOM) || false,
    name: NAME || "",
    slug: SLUG || "",
    title: TITLE || "",
    title1: TITLE_1,
    title2: TITLE_2,
    title3: TITLE_3,
    fontFamily: FONT_FAMILY || "",
    titleColor: TITLE_COLOR || "",
    titleSize: Number(TITLE_SIZE) || 28,
    titleSize1: Number(TITLE_SIZE_1),
    titleSize2: Number(TITLE_SIZE_2),
    titleSize3: Number(TITLE_SIZE_3),
    titleBottom: Boolean(TITLE_BOTTOM) || false,
    marginBottom: Number(MARGIN_BOTTOM) || 14,
    fontColor: FONT_COLOR || "#fff",
    priceFontColor: PRICE_FONT_COLOR || "",
    priceColor: PRICE_COLOR || "",
    fontSize: Number(FONT_SIZE) || 20,
    height: "400px",
    cardHeight: "250px",
    cardWidth: CARD_WIDTH || "300px",
    skinnyWidth: SKINNY_WIDTH || CARD_WIDTH || "300px",
    shortWidth: SHORT_WIDTH || "300px",
    shortHeight: SHORT_HEIGHT || "250px",
    cardPadding: "20px",
    defaultWidth: Number(DEFAULT_WIDTH) || 960,
    partnerCode: CODE || "antengo",
    membershipType: String(MEMBERSHIP_TYPE || ""),
    listings: LISTINGS || "//cache.sellwild.com/listings-img-data-sm", 
    listingsTagCacheCount: Number(LISTINGS_TAG_CACHE_COUNT) || 0,
    listingsTagCacheSelector: LISTINGS_TAG_CACHE_SELECTOR || "",
    localizedListings: parseValue(LOCALIZED_LISTINGS) || undefined,
    linkText: LINK_TEXT || "", 
    linkText1: LINK_TEXT_1, 
    linkText2: LINK_TEXT_2, 
    linkText3: LINK_TEXT_3,
    buyNowText: BUY_NOW_TEXT || '',
    linkSize: Number(LINK_SIZE) || 28, 
    linkSize1: Number(LINK_SIZE_1), 
    linkSize2: Number(LINK_SIZE_2), 
    linkSize3: Number(LINK_SIZE_3), 
    linkColor: LINK_COLOR || "",
    fontUrl: FONT_URL || "",
    colors: typeof COLORS === 'string' ? COLORS.split(',') : Array.isArray(COLORS) ? COLORS : ["#8c77b6","#baadd3","#f3f1f7"],
    bannerZid: BANNER_ZID || 0,
    bottomBannerZid: BOTTOM_BANNER_ZID || 0,
    mobileBannerZid: MOBILE_BANNER_ZID || 0,
    mobileZids: parseNums(MOBILE_ZID),
    displayZids: parseNums(DISPLAY_ZID),
    bidstreamStack: Number(BIDSTREAM_STACK),
    skyscraperZid: SKYSCRAPER_ZID || 0,
    gamTag: GAM_TAG || '',
    gamTagDesc: GAM_TAG_DESC || '',
    gamNetworkCode: GAM_NETWORK_CODE || '21824729475',
    gamCurrency: (GAM_CURRENCY || 'USD').toUpperCase(),
    usdToCadRate: Number(USD_TO_CAD_RATE) || 0,
    gamSlotPrefix: GAM_SLOT_PREFIX || 'w',
    gamUrlParser: GAM_URL_PARSER || 'default',
    col1: COL1 || '',
    col2: COL2 || '',
    col3: COL3 || '',
    col4: COL4 || '',
    col5: COL5 || '',
    col6: COL6 || '',
    optimizeFcp: Boolean(OPTIMIZE_FCP) || false,
    lotame: Boolean(LOTAME) || false,
    audigent: Boolean(AUDIGENT) || false,
    boltive: Boolean(BOLTIVE) || false,
    boltiveClientId: BOLTIVE_CLIENT_ID || '',
    boltiveClientIdMobile: BOLTIVE_CLIENT_ID_MOBILE || '',
    stickyStyle: STICKY_STYLE || '',
    gptProxyUrl: GPT_PROXY_URL || '',
    locationMap: LOCATION_MAP || "",
    adUnits: AD_UNITS || '',
    schainSid: SCHAIN_SID || '',
    schainAsi: SCHAIN_ASI || 'sellwild.com',
    s2sConfig: S2S_CONFIG || '',
    consentManagement: CONSENT_MANAGEMENT || '',
    growthcode: GROWTHCODE || '',
    bhTag: BH_TAG || '',
    ix: parseValue(IX),
    openx: parseValue(OPENX),
    medianet: parseValue(MEDIANET),
    across33: parseValue(ACROSS33),
    pubmatic: parseValue(PUBMATIC),
    yahoossp: parseValue(YAHOOSSP),
    amx: parseValue(AMX),
    appnexus: parseValue(APPNEXUS),
    mediafuse: parseValue(MEDIAFUSE),
    rubicon: parseValue(RUBICON),
    sovrn: parseValue(SOVRN),
    improveDigital: parseValue(IMPROVE_DIGITAL),
    unruly: parseValue(UNRULY),
    equativ: parseValue(EQUATIV),
    sharethrough: parseValue(SHARETHROUGH),
    sonobi: parseValue(SONOBI),
    onetag: parseValue(ONETAG),
    minutemedia: parseValue(MINUTEMEDIA),
    oms: parseValue(OMS),
    opscoPrebid: parseValue(OPSCO_PREBID),
    smaato: parseValue(SMAATO),
    nativo: parseValue(NATIVO),
    amazonAps: parseValue(AMAZON_APS),
    brave: parseValue(BRAVE),
    inmobi: parseValue(INMOBI),
    iqx: parseValue(IQX),
    zetaGlobalSsp: parseValue(ZETA_GLOBAL_SSP),
    omnidex: parseValue(OMNIDEX),
    adGeoBlock: parseValue(AD_GEO_BLOCK),
    adGeoBlockRefresh: parseValue(AD_GEO_BLOCK_REFRESH),
    pubVentures: parseValue(PUB_VENTURES),
    saambaa: parseValue(SAAMBAA),
    opsco: parseValue(OPSCO),
    apstag: parseValue(APSTAG),
    bidstream: parseValue(BIDSTREAM),
    breakpoints: parseValue(BREAKPOINTS),
    nobid: parseValue(NOBID),
    cpmstar: parseValue(CPMSTAR),
    insticator: parseValue(INSTICATOR),
    yieldmo: parseValue(YIELDMO),
    epsilon: parseValue(EPSILON),
    triplelift: parseValue(TRIPLELIFT),
    adType: AD_TYPE || '',
    standaloneAdType: STANDALONE_AD_TYPE || '',
    safeFrame: parseValue(SAFE_FRAME) === true,
    adRefreshMax: Number(AD_REFRESH_MAX) || 0,
    adRefreshMaxMobile: AD_REFRESH_MAX_MOBILE !== undefined && AD_REFRESH_MAX_MOBILE !== '' ? Number(AD_REFRESH_MAX_MOBILE) : -1,
    adRefreshMaxIosSafari: AD_REFRESH_MAX_IOS_SAFARI !== undefined && AD_REFRESH_MAX_IOS_SAFARI !== '' ? Number(AD_REFRESH_MAX_IOS_SAFARI) : -1,
    adRefreshInterval: Number(AD_REFRESH_INTERVAL) || 0,
    lazyLoadAds: Boolean(LAZY_LOAD_ADS) || false,
    refreshOnViewOnly: Boolean(REFRESH_ON_VIEW_ONLY) || false,
    adDisableDisplay: Boolean(AD_DISABLE_DISPLAY),
    // Default on. Explicit false/0/off disables listing backfill on empty ad slots.
    houseAdEnabled: HOUSE_AD_ENABLED === undefined || HOUSE_AD_ENABLED === ''
      ? true
      : !['0', 'false', 'no', 'off'].includes(String(HOUSE_AD_ENABLED).toLowerCase()),
    adStack: AD_STACK || '',
    adStackByZone: parseValue(AD_STACK_BY_ZONE) || {},
    maxFailedAuctions: Number(MAX_FAILED_AUCTIONS) || 0,
    identityHub: Boolean(IDENTITY_HUB) || false,
    prebidDefer: Number(PREBID_DEFER) || 0,
    prebidSrc: PREBID_SRC || '',
    floorMultiplier: Number(FLOOR_MULTIPLIER) || 1,
    mediaFuseWrapper: MEDIA_FUSE_WRAPPER || '',
    adsenseClientId: ADSENSE_CLIENT_ID || '',
    gppEnabled: Boolean(GPP_ENABLED) || false,
    tcfVersion: Number(TCF_VERSION) || 2,
    watermark: Boolean(WATERMARK),
    watermarkTitle: WATERMARK_TITLE || 'These for sale listings + ads are from the Sellwild Marketplace. Click here to sell your own items (featured here & on other notable sites w/ millions of users) for FREE',
    css: CSS || '',
    noResize: Boolean(NO_RESIZE) || false,
    footer: FOOTER || '',
    search: SEARCH || '',
    searchBottom: Boolean(SEARCH_BOTTOM) || false,
    disableDark: Boolean(DISABLE_DARK) || false,
    disableGpt: Boolean(DISABLE_GPT) || false,
    darkClass: DARK_CLASS || '',
    placeholder: PLACEHOLDER || '',
    imgBkg: Boolean(IMG_BKG) || false,
    iabCats: parseArray(IAB_CATS),
    flipCardColor: FLIP_CARD_COLOR || '#f07830',
    // Empty string is intentional (hide copy); only fall back when unset.
    flipCardTitle: FLIP_CARD_TITLE ?? 'Marketplace',
    flipCardSubtitle: FLIP_CARD_SUBTITLE ?? 'Hot deals available',
    flipCardCta: FLIP_CARD_CTA ?? 'View marketplace',
    minBidCacheTTL: MIN_BID_CACHE_TTL !== undefined && MIN_BID_CACHE_TTL !== '' ? Number(MIN_BID_CACHE_TTL) : -1,
    eventHistoryTTL: EVENT_HISTORY_TTL !== undefined && EVENT_HISTORY_TTL !== '' ? Number(EVENT_HISTORY_TTL) : -1,
    syncsPerBidder: SYNCS_PER_BIDDER !== undefined && SYNCS_PER_BIDDER !== '' ? Number(SYNCS_PER_BIDDER) : -1,
    syncsPerBidderIos: SYNCS_PER_BIDDER_IOS !== undefined && SYNCS_PER_BIDDER_IOS !== '' ? Number(SYNCS_PER_BIDDER_IOS) : -1,
    identityEnabled: Boolean(IDENTITY_ENABLED) || false
}

type CustomizationMap = { [key: string]: keyof ICustomizations }

// Generate customization map programmatically from defaultCustomizations keys
const generateCustomizationMap = (defaults: ICustomizations): CustomizationMap => {
    const map: CustomizationMap = {}

    for (const key of Object.keys(defaults) as (keyof ICustomizations)[]) {
        // camelCase (original)
        map[key] = key
        // snake_case
        map[camelToSnake(key)] = key
        // kebab-case
        map[camelToKebab(key)] = key
        // CONSTANT_CASE
        map[camelToConstant(key)] = key
    }

    return map
}

const customizationMap: CustomizationMap = generateCustomizationMap(defaultCustomizations)

function parseArray (value: any) {
    if (Array.isArray(value)) return value
    return parseValue((value || '').replace('List ', ''))
}
function parseValue (value: string|undefined) {
    if (!value) return value
    try {
        return JSON.parse(value)
    } catch (e) {
        return value
    }
}

function parseNums (value = '') {
    return String(value || '').split(',').map(v => Number(v.trim()) || v)
}

let partnerCode = 'antengo'
export const getPartnerCode = () => {
    return partnerCode
}

export const withCustomizationsFromUrl = (location: Window['location'], initial: ICustomizations): ICustomizations => {
    const url = location.href.split("?");
    if (url[1]) {
        return url[1].split("&")
        .map(val => val.split("="))
        .reduce((acc, [c, val]) => {
            const key = customizationMap[c]
            if (acc.hasOwnProperty(key) && val && val !== 'undefined') {
                if (key === 'listings') {
                    (acc as any)[key] = decodeURIComponent(val)
                } else if (key === 'fontFamily') {
                    (acc as any)[key] = decodeURIComponent(val)
                } else if (key === 'fontUrl') {
                    (acc as any)[key] = decodeURIComponent(val)
                } else if (key === 'fontColor') {
                    (acc as any)[key] = decodeURIComponent(val)
                } else if (key === 'titleColor') {
                    (acc as any)[key] = decodeURIComponent(val)
                } else if (key === 'linkColor') {
                    (acc as any)[key] = decodeURIComponent(val)
                } else if (key === 'buyNowText') {
                    (acc as any)[key] = decodeURIComponent(val)
                } else if (key === 'priceColor') {
                    (acc as any)[key] = decodeURIComponent(val)
                } else if (key === 'priceFontColor') {
                    (acc as any)[key] = decodeURIComponent(val)
                } else if (key === 'colors') {
                    (acc as any)[key] = decodeURIComponent(val).split(',').filter(v => v)
                } else if (key === 'gamTag') {
                    (acc as any)[key] = decodeURIComponent(val)
                } else if (key === 'gamTagDesc') {
                    (acc as any)[key] = decodeURIComponent(val)
                } else if (key === 'gamNetworkCode') {
                    (acc as any)[key] = decodeURIComponent(val)
                } else if (key === 'gamCurrency') {
                    (acc as any)[key] = decodeURIComponent(val).toUpperCase()
                } else if (key === 'usdToCadRate') {
                    (acc as any)[key] = Number(decodeURIComponent(val)) || 0
                } else if (key === 'adUnits') {
                    (acc as any)[key] = decodeURIComponent(val)
                } else if (key === 'mediaFuseWrapper') {
                    (acc as any)[key] = decodeURIComponent(val)
                } else if (key === 'adsenseClientId') {
                    (acc as any)[key] = decodeURIComponent(val)
                } else if (key === 'css') {
                    (acc as any)[key] = decodeURIComponent(val)
                } else if (key === 'displayZids') {
                    (acc as any)[key] = parseNums(decodeURIComponent(val))
                } else if (key === 'mobileZids') {
                    (acc as any)[key] = parseNums(decodeURIComponent(val))
                } else if (key === 'yahoossp') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'pubmatic') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'ix') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'amx') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'appnexus') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'mediafuse') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'rubicon') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'sovrn') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'improveDigital') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'unruly') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'equativ') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'sharethrough') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'sonobi') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'onetag') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'minutemedia') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'oms') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'opscoPrebid') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'smaato') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'nativo') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'amazonAps') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'brave') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'inmobi') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'iqx') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'zetaGlobalSsp') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'omnidex') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'nobid') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'cpmstar') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'insticator') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'yieldmo') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'epsilon') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'triplelift') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'pubVentures') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'saambaa') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'opsco') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'bidstream') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'apstag') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'adGeoBlock') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'adGeoBlockRefresh') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'breakpoints') {
                    (acc as any)[key] = parseValue(decodeURIComponent(val))
                } else if (key === 'iabCats') {
                    (acc as any)[key] = parseArray(decodeURIComponent(val))
                } else if (key === 'prebidSrc') {
                    (acc as any)[key] = decodeURIComponent(val)
                } else if (key === 'floorMultiplier') {
                    (acc as any)[key] = Number(decodeURIComponent(val)) || 1
                } else if (key === 'listingsTagCacheSelector') {
                    (acc as any)[key] = decodeURIComponent(val)
                } else {
                    (acc as any)[key] = parseValue(val) 
                }
            }
            return acc
        }, initial)
    }
    return initial
}

const numberArrayKeys = ['mobileZids', 'displayZids']

export const withCustomizationsFromElement = (element: Element, initial: ICustomizations): ICustomizations => {
    return Object.keys(customizationMap)
    .reduce((acc, c) => {
        const value = element.getAttribute(c)
        if (!value) return acc;
        if (customizationMap[c] === 'colors') {
            (acc as any)[customizationMap[c]] = value.split(',').filter(v => v)
        } else if (numberArrayKeys.indexOf(customizationMap[c]) !== -1) {
            (acc as any)[customizationMap[c]] = parseNums(decodeURIComponent(value))
        } else {
            (acc as any)[customizationMap[c]] = parseValue(value)
        }
        return acc
    }, initial)
}

export const getCustomizations = (location: Window['location'], element: Element): ICustomizations => {
    const fromElement = withCustomizationsFromElement(
        element,
        defaultCustomizations
    )
    const customizations = withCustomizationsFromUrl(
        location,
        fromElement
    )
    if (customizations.partnerCode) {
        partnerCode = customizations.partnerCode
    }
    return customizations
}

const getCustomizationsUrl = (options: ICustomizations) => {
    if (options.locationMap) {
        try {
            const mapping = JSON.parse(decodeURIComponent(options.locationMap))
            const hostname = window.location.hostname || window.location.host || ''
            const value = mapping[options.slug][hostname.replace('www.', '')]
            if (value) {
                // WE WANT TO USE THE LOCATION NOT THE PARTNER CODE AND SLUG
                return value
            }
        } catch (e) {
            // console.error('Failed to parse locationMap', e)
        }
    }
    return `https://widget.sellwild.com/${options.partnerCode}/${options.slug}.json`
}

export const loadCustomizations = async (options: ICustomizations) => {
    // Skip loading remote customizations if customize is false
    if (options.customize === false) {
        console.log("SKIPPING CUSTOMIZATION LOAD, USING SUPPLIED CUSTOMIZATIONS", options)
        return
    }
    try {
        const url = getCustomizationsUrl(options)
        const customizations = await fetch(url).then(r => r.json())
        for (const key in customizations) {
            const camelKey = constantToCamelCase(key) as keyof ICustomizations
            if (options && typeof options === 'object' && options.hasOwnProperty(camelKey) && options[camelKey] !== customizations[key]) {
                (options as any)[camelKey] = customizations[key]
                // console.log(`Customization ${camelKey} set to ${customizations[key]}`)
            }
        }
    } catch (e) {
        console.error('Failed to load customizations', e)
    }
}

const browseUrl = 'https://browse.sellwild.com/itemDetail'
const legacyUrl = 'https://sellwild.com/product'

const random = Math.random()

const constantToCamelCase = (str: string) => {
    if (str === 'CODE') return 'partnerCode'
    return str.toLowerCase().split('_').map((word, i) => i === 0 ? word : word[0].toUpperCase() + word.slice(1)).join('')
}

export const getListingUrl = (listing: {id: string; url: string; dataSourceId: string; remote_url?: string}, config: any, theme: ICustomizations) => {
    const qs = `p=${theme.partnerCode}&utm_source=${theme.partnerCode}`
    let url = ''
    if (listing.url) {
        if (theme.bhTag) {
            const url = new URL(listing.url)
            url.searchParams.set('tag', theme.bhTag)
            return url.toString()
        }
        return listing.url
    } else if (String(listing.dataSourceId) === '31' && listing.remote_url) {
        return listing.remote_url
    } else if (config && typeof config.browse === "number") {
        url = ((random > config.browse) ? legacyUrl : browseUrl)
    } else {
        url = theme.browse ? browseUrl : legacyUrl
    }
    return `${url}/${listing.id}?${qs}`
}

export const getMainUrl = (theme: ICustomizations, path: string, content: string) => {
    const qs = `?p=${theme.partnerCode}&utm_source=${theme.partnerCode}&utm_content=${content}`
    return `https://sellwild.com/${path}${qs}`
}

export function makeCustomizationController (element: HTMLElement, search: URLSearchParams) {
    function getValue (name: string, def: string = '') {
      return getAttributeAnyCasing(element, name) || search.get(name) || def
    }
  
    function getNumber (name: string, def: number = 0) {
      const value = getValue(name)
      return Number(value) || def
    }
  
    function getObject (name: string, def: unknown) {
      const value = getValue(name)
      try {
        return JSON.parse(value)
      } catch (err) {
        return def
      }
    }
  
    return {
      getValue,
      getNumber,
      getObject,
    }
  }